import { createContext, useState } from "react";

export const ButtonVisibilityContext = createContext();

export const ButtonVisibilityProvider = ({children})=>{
   const [showButton, setShowButton] = useState(true);

   return (
    <ButtonVisibilityContext.Provider value={{showButton,setShowButton}}>
        {children}
    </ButtonVisibilityContext.Provider>
   )
}